/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { adminAssetsUploadImage } from "../funcs/adminAssetsUploadImage.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { UploadImageResult } from "../models/components/uploadimageresult.js";
import {
  UploadPlatformImageRequest,
  UploadPlatformImageSecurity,
} from "../models/operations/uploadplatformimage.js";
import { unwrapAsync } from "../types/fp.js";

export class AdminAssets extends ClientSDK {
  /**
   * uploadPlatformImage adminAssets
   *
   * @remarks
   * Upload a platform-tier image (e.g. a global remote identity provider logo). Requires platform admin.
   */
  async uploadImage(
    request: UploadPlatformImageRequest,
    security?: UploadPlatformImageSecurity | undefined,
    options?: RequestOptions,
  ): Promise<UploadImageResult> {
    return unwrapAsync(adminAssetsUploadImage(
      this,
      request,
      security,
      options,
    ));
  }
}
